import { Random, JSONStorage } from "@byloth/core";

export const jsonStorage = new JSONStorage();

export interface RandomCharsOptions
{
    withUppercase?: boolean;
    withNumbers?: boolean;
    withSimpleSpecials?: boolean;
    withComplexSpecials?: boolean;
    withSpaces?: boolean;
}

export function randomChar(options: RandomCharsOptions = { }): string
{
    const _isBetween = (value: number, [min, max]: [number, number]) => (value >= min) && (value <= max);
    const _isIn = (value: number, values: number[]) => values.includes(value);
    const _isComplex = (value: number) =>
    {
        if (_isIn(value, [44, 47, 96])) { return true; }
        if (_isBetween(value, [33, 42])) { return true; }
        if (_isBetween(value, [58, 64])) { return true; }
        if (_isBetween(value, [91, 94])) { return true; }
        if (_isBetween(value, [123, 126])) { return true; }

        return false;
    };

    let char: number;
    let isValid = false;

    do
    {
        char = Random.Integer(32, 127);

        if (_isBetween(char, [97, 122]))
        {
            isValid = true;
        }
        else if ((options.withUppercase) && _isBetween(char, [65, 90]))
        {
            isValid = true;
        }
        else if ((options.withNumbers) && _isBetween(char, [48, 57]))
        {
            isValid = true;
        }
        else if ((options.withSimpleSpecials) && _isIn(char, [43, 45, 46, 95]))
        {
            isValid = true;
        }
        else if ((options.withComplexSpecials) && _isComplex(char))
        {
            isValid = true;
        }
        else if ((options.withSpaces) && (char === 32))
        {
            isValid = true;
        }
    }
    while (!(isValid));

    return String.fromCharCode(char);
}

export function randomString(length: number, options?: RandomCharsOptions): string;
export function randomString(min: number, max: number, options?: RandomCharsOptions): string;
export function randomString(min: number, max?: number | RandomCharsOptions, options: RandomCharsOptions = { }): string
{
    let length: number;
    if (!(max))
    {
        length = min;
    }
    else if (typeof max === "object")
    {
        length = min;
        options = max;
    }
    else
    {
        length = Random.Integer(min, max);
    }

    let string = "";
    for (let i = 0; i < length; i += 1)
    {
        string += randomChar(options);
    }

    return string;
}
